export enum ProjectPreviewEventType {
  UPDATE_PROJECT,
  TOGGLE_RIGHT_SECTION,
  CHANGE_STAGE
}
